<mat-dialog-content
  class="app-faculties-selection-list-restriction-form-dialog"
>
  <app-input-group
    [formArray]="newRestrictions"
    (add)="addRestriction()"
    title="Restricciones"
  >
    @for (newRestriction of newRestrictions.controls; track $index) {
      <div class="restriction-container">
        <app-faculties-selection-list-restriction-form
          [restriction]="newRestriction"
        ></app-faculties-selection-list-restriction-form>
        <button
          mat-icon-button
          title="Eliminar restricción"
          (click)="removeRestrictionAtIndex($index)"
          [disabled]="$index < 1"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </app-input-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    [mat-dialog-close]="true"
    [disabled]="newRestrictions.invalid"
    (click)="handleRestrictions()"
  >
    Añadir
  </button>
</mat-dialog-actions>
